import { RootState } from "@/store/store";
import { FilterTreeNode } from "@/services/cloudchipr.api";
import { savingsOpportunityCurrentViewConfigSelector } from "@/store/savings-opportunities/selectors/views-hierarchy/current-view/savingsOpportunityCurrentViewConfigSelector";

export const savingsOpportunitiesCurrentViewFiltersSelector = (
  state: RootState,
): FilterTreeNode | undefined => {
  const config = savingsOpportunityCurrentViewConfigSelector(state);

  return config?.filters as FilterTreeNode;
};
